'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('TenantsOverviewCtrl', TenantsOverviewCtrl);

  TenantsOverviewCtrl.$inject =
    ['$scope', 'errorMessageService', 'Auth', 'Labels', 'tenants', 'User', 'Constants', '$state'];

  function TenantsOverviewCtrl ($scope, errorMessageService, Auth, Labels, tenants, User, Constants, $state) {
    const vm = this;

    vm.LABELS = Labels;
    vm.tenants = tenants;
    vm.userLanguages = Constants.getList('USER_LANGUAGES');

    vm.$onInit = () => {
      vm.update();
      $scope.$emit('hideMenu', true);
    };

    // Not sure if this is the proper way to fetch the user Tenants
    vm.update = () => {
      vm.user = Auth.getCurrentUser();

      vm.currentDatabases = vm.tenants.filter((tenant) => {
        if(angular.isDefined(vm.user.databases) && angular.isArray(vm.user.databases)) {
          return vm.user.databases.includes(tenant.name);
        }
      });
    };

    vm.getTenantAvatar = (tenant) => {
      tenant.images = tenant.uploads.filter((upload) => upload.file.type.includes('image/'));

      if (tenant.images.length === 0) {
        tenant.images.push({
          path: '/static/images/menu_logo.png',
          file: {
            type: 'image/png'
          }
        });
      }

      return tenant.images[0].path;
    };

    vm.loadTenant = (tenant) => {
      tenantActions.load(tenant).then((u) => {
        Object.assign(vm.user, {u});
        vm.update();
        tenantActions.responseUpdate(angular.isDefined(vm.user));
      });
    };

    /**
     * We need to define the current tenant index
     * The tenant should then be moved accordingly to the 0 index while pushing the remaining tenants
     */
    const tenantActions = {
      load: (item) => {

        const currentUser = Auth.getCurrentUser(); // Always get the latest information from the current user
        const selectedTenant = currentUser.databases.find((db) => db === item.name);
        const others = currentUser.databases.filter((db) => db !== item.name);
        currentUser.databases = [selectedTenant, ...others];

        return updateUser(currentUser);
      },

      responseUpdate: (response) => {
        if (response) {
          Constants.invalidate();
          $scope.$emit('hideMenu', false);
          $state.go('project', null, {reload: true, notify: true} );
        }
      }
    };

    const updateUser = (user) => {

      // versionId should be created by Mongo
      delete user.__v;

      const userToUpdate = {
        _id: user._id,
        user: user
      };

      return User.updateUserTenant(userToUpdate).$promise.then((users) => {
        const updatedUser = users.find((u) => u._id === userToUpdate._id);
        errorMessageService.showToast(
          vm.LABELS.getLabel('tenantselected'),
          true
        );

        vm.update();
        return updatedUser;
      });
    };
  };
})();
